import React, { useState, useEffect } from 'react'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  CheckPicker,
  Icon,
  IconButton,
  Button,
  Input,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { useHistory } from 'react-router-dom'
import pathname from '../../../constants/pathname'
import PdfRenderWidgets from '../../pdfWidgets/PdfRenderWidgets'
import { isValidators } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'
import PreviewButton from '../../../components/buttons/previewButton/PreviewButton'
import TableReport from '../../adminReport/tableReport/TableReport'
import {
  exportAssetprojectregistration,
  searchAssetprojectregistration,
} from '../../../redux/actions/addDurableArticles'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { downloadFile } from '../../../utils/fileUtil'

export default function AssetRegisterReportWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [dataTable, setDataTable] = useState()
  const [isExpanded, setIsExpanded] = useState(true)
  const [isError, setIsError] = useState(false)
  const history = useHistory()
  const [columnsValue, setColumnsValue] = useState(props.schema.columns.defaultValue)
  const [errorMsg, setErrorMsg] = useState()

  // console.log('columnsValue ', columnsValue)

  const onPreview = (data) => {
    console.log('onPreview ', data)

    let dataColumns = '',
      countColumns = data.columns.length - 1

    if (countColumns > 0) {
      data.columns.map((item, index) => {
        if (countColumns == index) {
          dataColumns += `${item}`
        } else {
          dataColumns += `${item},`
        }
      })
    }

    const request = {
      pageNumber: 1,
      pageSize: 25,
      columns: dataColumns,
      projectCode: data.projectCode,
    }

    handleGetSchema(request)
  }

  const handleGetSchema = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await searchAssetprojectregistration(request)
      console.log('schema => ', _schema.model)
      setDataTable(_schema.model)
      // setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handelGetSchemaOnReload = (pagesize, pagenumber) => {
    console.log('handelGetSchemaOnReload ', pagesize, pagenumber)

    let dataColumns = '',
      countColumns = columnsValue.length - 1

    if (countColumns > 0) {
      columnsValue.map((item, index) => {
        if (countColumns == index) {
          dataColumns += `${item}`
        } else {
          dataColumns += `${item},`
        }
      })
    }

    const request = {
      pageNumber: pagenumber,
      pageSize: pagesize,
      columns: dataColumns,
    }

    handleGetSchema(request)
  }

  const exportToExcel = (data) => {
    console.log('exportToExcel ', data)

    let newArr = []
    if (data.columns.length > 0) {
      data.columns.map((item) => {
        //เอาออกตามเงื่อนไข สสส.
        if (item != 'projectName' && item != 'reserveProjectName') {
          newArr.push(item)
        }
      })
    }

    const request = {
      columns: newArr || [],
      projectCode: data.projectCode,
    }

    handleExportFile(request)
  }

  const handleExportFile = async (request) => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const file = await exportAssetprojectregistration(request)

      if (file) {
        downloadFile(file, file.name || `รายงานทะเบียนครุภัณฑ์โครงการ`)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      // let errorJson = JSON.parse(await e.response.data.text())
      setIsError(true)
      // handelSetErrorMsg('error', errorJson?.errors?.message)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={''}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
        }}
      >
        {isLoading && !isError && <OverlayLoader />}

        {/* <MiniProjectInfo schema={formSchema?.projectInfo} /> */}
        <Row style={{ marginTop: 30 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.projectCode.label}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <Input
              name={formSchema?.projectCode?.name}
              defaultValue={formSchema?.projectCode?.value}
              placeholder={formSchema?.projectCode?.hint || 'เลือกรหัสโครงการ'}
              inputRef={register()}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 8 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.columns.label}
          </Col>
          <Col lg={12} md={12} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.columns.name]} />
            <Controller
              name={formSchema.columns.name}
              control={control}
              rules={isValidators(formSchema.columns.validators)}
              defaultValue={formSchema.columns.options.map((columns) => {
                const { value } = columns
                return value
              })}
              render={(props) => {
                return (
                  <CheckPicker
                    sticky
                    data={formSchema.columns.options}
                    defaultValue={formSchema.columns.defaultValue}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      console.log('x => ', value)
                      setColumnsValue(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {/* <Button appearance="ghost" color="#2da888">
              <Icon icon="eye" /> Preview
            </Button> */}
            <PreviewButton onClick={handleSubmit(onPreview)} />

            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
              onClick={handleSubmit(exportToExcel)}
              style={{ marginLeft: 5, marginTop: -10 }}
            >
              Export to Excel
            </IconButton>
          </Col>
        </Row>

        {errorMsg && (
          <Message
            showIcon
            type={errorMsg.type}
            description={errorMsg.description}
            style={{ marginBottom: 20 }}
          />
        )}

        {dataTable && (
          <Row>
            <TableReport
              schema={dataTable}
              headerHeightSize={40}
              Controller={Controller}
              control={control}
              pagination={true}
              loading={isLoading}
              shaded={false}
              onReload={handelGetSchemaOnReload}
              // onClickExport={handleSubmit(handleOnClickExport)}
              // onClickLinked={handleClickLinked}
            />
          </Row>
        )}
      </Panel>
    </>
  )
}
